// src/configuracion.js
//
// ┌─ Edge server (localhost O IP de red, puerto 8765) → ''
// │    URLs relativas → el proxy del edge server las intercepta.
// └─ tavgol.com / cualquier otro hosting             → 'https://bts.ei-solutions.co'
//      Llamadas CORS directas al backend.
//
const _isEdgeServer =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
   window.location.hostname === '127.0.0.1' ||
   window.location.port === '8765');   // ← cualquier IP en el puerto del edge server

export const IP = _isEdgeServer ? '' : 'https://bts.ei-solutions.co';
